module.exports = __webpack_public_path__ + "static/media/view off game.3d309937.svg";